export default __webpack_public_path__ + "images/8fa1ec888ea3773ce4b000cf807f2c03-icon-price.svg";